<div>
	<ul class="nav nav-tabs" role="tablist" aria-label="Tabs">
		<li
			*ngFor="let tab of tabs; let i = index"
			role="tab"
			(click)="selectTab(tab)"
			(keydown)="onTabKeydown($event, i)"
			[class.active]="tab.active"
			[attr.aria-selected]="tab.active"
			[attr.tabindex]="tab.active ? 0 : -1"
		>
			<a #tabTrigger href="#" (click)="$event.preventDefault(); selectTab(tab)">
				<ng-container *ngIf="tab.titleTemplate; else plainTitle">
					<ng-container *ngTemplateOutlet="tab.titleTemplate"></ng-container>
				</ng-container>
				<ng-template #plainTitle>{{ tab.title }}</ng-template>
			</a>
		</li>
	</ul>
	<ng-content></ng-content>
</div>
